import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

import TitleSection from "../components/TitleSection/TitleSection";
import LiveGames from "../components/Poker/LiveGames";
import Tournaments from "../components/Poker/Tournaments";
import JoinTheClub from "../components/HomePage/JoinTheClub";
import BbjHero from "../components/Poker/BbjHero";
import HeroCarousel from "../components/Carousel/HeroCarousel";
import { useHubData } from "src/hooks/useHubData";
import { fetchPokerCarousel } from "src/api/payload/pokerCarousel";

const Poker = () => {
  const { i18n, t } = useTranslation();

  const { data: carouselData } = useHubData(
    "carousels",
    {
      fetchPayloadData: fetchPokerCarousel,
      ersKeyPrefix: "carousel-poker",
    },
    i18n.language
  );

  const slides =
    Array.isArray(carouselData) && carouselData.length > 0
      ? carouselData
      : [t("defaultHeroCarousel.loading", { returnObjects: true })];

  return (
    <PokerDiv>
      <switcheroo-holder>
        <TitleSection
          title={t("poker.title")}
          text={t("poker.title-text")}
          className="pb-3"
        />
        <HeroCarousel carouselData={slides} />
      </switcheroo-holder>

      <BbjHero compact className="mt-3" />
      <LiveGames />
      <Tournaments />
      <JoinTheClub />
    </PokerDiv>
  );
};

const PokerDiv = styled.div`
  width: 100%;
  background: var(--black);
  position: relative;
`;

export default Poker;
